import styled from '@emotion/styled'
import { lighten } from 'polished'

export const Container = styled.div`
  background: ${(props) => props.theme.palette.common.white};
  padding: '1rem';
  border-radius: '0.5rem';
  & > .item {
    padding: 0 1rem;
    margin-top: 1rem;
  }
  
  & > .item:nth-child(odd) {
    background: ${(props) => props.theme.palette.grey[100]};
    border-radius: 1rem;
  }
`

export const SelectComissionItem = styled.div`
  display: flex;
  align-items: center;
  gap: .6rem;
  padding-left: .8rem;

  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: .6rem;

  font-size: .9rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grey[800]};

  button {
    border: 0;
    background: white;
    height: 100%;
    cursor: pointer;
    height: 36px;
    border-radius: .6rem;
    transition: background .1s ease-in-out;

    &:hover {
      background: ${({ theme }) => lighten('0.35', theme.palette.error.main)};
    }
  }
`
